
import React, { Component } from 'react';
import { render } from 'react-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { getVymeraStringWithUnitHa } from '../../common/common/iskn/vymera';

let resolve;

const classNames = mergeStyleSets({
    dialogContent: {
    },
    clusterInfo: {
        paddingBottom: 16
    },
    categoryItemTitle: {
        fontWeight: 'bold'
    },
    clusterValues: {
        paddingLeft: 16
    },
    value: {
        fontWeight: 'bold'
    }
});

const ClusterInfo = ({clustersDataItem}) => {
    if (clustersDataItem.clustersInfo.length > 0) {
        let info = clustersDataItem.clustersInfo[0];
        return (
            <Stack className={classNames.clusterInfo}>
                <Stack.Item className={classNames.categoryItemTitle}>{clustersDataItem.item_title}</Stack.Item>
                <Stack horizontal tokens={{childrenGap: 4}} className={classNames.clusterValues} >
                    <Stack.Item>Největší souvislé území má výměru</Stack.Item>
                    <Stack.Item className={classNames.value}>{getVymeraStringWithUnitHa(info.area)}</Stack.Item>
                    <Stack.Item>na</Stack.Item>
                    <Stack.Item className={classNames.value}>{info.count}</Stack.Item>
                    <Stack.Item>parcelách (ID {info.cluster_id})</Stack.Item>
                </Stack>
            </Stack>
        );
    } else {
        return (
            <Stack className={classNames.clusterInfo}>
                <Stack.Item className={classNames.categoryItemTitle}>{clustersDataItem.item_title}</Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}} className={classNames.clusterValues} >
                    <Stack.Item>Neobsahuje žádné parcely</Stack.Item>
                </Stack>
            </Stack>
        );
    }
}

const DialogContent = ({clustersData}) => {

    return (
        <div className={classNames.dialogContent}>
            {clustersData.map((item, index) => {
                return (
                    <ClusterInfo
                        key={index}
                        clustersDataItem={item}
                    />
                );
            })}
        </div>
    );
}

class DialogClustersInfo extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogClustersInfo />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            clustersData: null,
            onExportCsv: null,
            onExportGeoJson: null
        };
    }

    checkValues() {
        let warnings = [];
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve(true);
        }
    }

    handleExportCsv = () => {
        if (this.state.onExportCsv) {
            this.state.onExportCsv();
        }
    }

    handleExportGeoJson = () => {
        if (this.state.onExportGeoJson) {
            this.state.onExportGeoJson();
        }
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={600}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Souvislost parcel v aktuální kategorii"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <DialogContent
                        clustersData={this.state.clustersData}
                    />
                <DialogFooter>
                    <DefaultButton onClick={this.handleExportCsv} text="Export do CSV" />
                    <DefaultButton onClick={this.handleExportGeoJson} text="Export do GeoJSON" />
                    <PrimaryButton onClick={this.handleCancel} text="Zavřít" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(clustersData, onExportCsv, onExportGeoJson) {
        this.setState({
            hidden: false,
            clustersData,
            onExportCsv,
            onExportGeoJson
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogClustersInfo.create();
